module.exports = __webpack_public_path__ + "img/img_shouxinchongshenka3@2x.7c8a5071.png";